import React from 'react';
import { downloadFile } from "@common/utils/downloadFile";

export const LayoutByIframe = ({ config, filePath }) => {
  React.useEffect(() => {
    /** Сделано автоматическое скачивание, потому что мобильные браузеры андройда не умеют читать pdf файлы **/
    if (navigator.userAgent.match(/Android/i)) {
      const docName = filePath.split('/');
      downloadFile(`${config.api.url}${filePath}`, docName[docName.length - 1]);
    }
  }, []);

  return (
    <div style={{ height: '100vh' }}>
      <iframe
        src={`${config.api.url}${filePath}`}
        style={{ width: '100%', height: '100vh' }}
      />
    </div>
  );
};
